import { NgModule, ModuleWithProviders, Inject, Optional, InjectionToken, SkipSelf } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { MixpanelEventDirective } from './mixpanel-event.directive';
import { MixpanelService } from '@app/shared/misc/analytics/mixpanel.service';
import { OpenPanelService } from '@app/shared/misc/analytics/open-panel.service';

export const MIXPANEL_ROOT_GUARD = new InjectionToken('MIXPANEL_ROOT_GUARD');
export function provideForRootGuard(analytics: AnalyticsService): any {
  if (analytics) {
    throw new Error(`Analytics Module.forRoot() called twice. Lazy loaded modules should use forChild().`);
  }
  return 'guarded';
}

@NgModule({
  declarations: [MixpanelEventDirective],
  exports: [MixpanelEventDirective],
})
export class MixpanelModule {
  static forRoot(): ModuleWithProviders<MixpanelModule> {
    return {
      ngModule: MixpanelModule,
      providers: [
        {
          provide: MIXPANEL_ROOT_GUARD,
          useFactory: provideForRootGuard,
          deps: [[AnalyticsService, new Optional(), new SkipSelf()]],
        },
        AnalyticsService,
        MixpanelService,
        OpenPanelService,
      ],
    };
  }

  static forChild(): ModuleWithProviders<MixpanelModule> {
    return {
      ngModule: MixpanelModule,
      providers: [],
    };
  }
  constructor(@Optional() @Inject(MIXPANEL_ROOT_GUARD) guard: any) {}
}
